/**
 * Inicialización de Firebase App
 * Centraliza la config y la inicialización de Firebase para toda la aplicación.
 * Usa variables de entorno inyectadas por Webpack DefinePlugin.
 * NO hardcodea credenciales reales en el código fuente.
 */

import { initializeApp, getApps } from 'firebase/app';

// Configuración desde variables de entorno (inyectadas por Webpack)
// En desarrollo, usarán placeholders si no están definidas
const firebaseConfig = {
  apiKey: process.env.FIREBASE_API_KEY,
  authDomain: process.env.FIREBASE_AUTH_DOMAIN,
  projectId: process.env.FIREBASE_PROJECT_ID,
  storageBucket: process.env.FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.FIREBASE_APP_ID
};

// Validación básica de config
const isValidConfig = firebaseConfig.apiKey && 
                      firebaseConfig.projectId && 
                      !firebaseConfig.apiKey.includes('PLACEHOLDER');

if (!isValidConfig) {
  console.error('[Firebase] ❌ Error de configuración:', firebaseConfig);
  console.warn('[Firebase] ⚠️ Configuración incompleta o usando placeholders. ' +
    'La app funcionará en modo offline/mock. ' +
    'Asegúrate de tener el archivo .env configurado correctamente y reiniciar el servidor.');
}

// Singleton pattern: inicializar solo si no existe
// Esto previene errores de re-inicialización en hot reload
let app;
if (getApps().length === 0) {
  app = initializeApp(firebaseConfig);
  console.log('[Firebase] ✅ App inicializada correctamente');
} else {
  app = getApps()[0];
  console.log('[Firebase] ℹ️ Usando instancia existente');
}

export { app };
